export default __webpack_public_path__ + "8ae20dc35eb629826c46aede4d7d82a9.png";